// Increment
function arrivalIncrement(button, selector) {
	const liNode = button.closest(selector),
		input = liNode.querySelector('.Counter__input')

	input.value = Number(input.value) + 1

	arrivalCheckboxHandler(liNode, !!Number(input.value))
	arrivalUpdateDataset(liNode, 'quantity', Number(input.value))
}

// Decrement
function arrivalDecrement(button, selector) {
	const liNode = button.closest(selector),
		input = liNode.querySelector('.Counter__input')

	if (Number(input.value)) {
		input.value = Number(input.value) - 1
	}

	arrivalCheckboxHandler(liNode, !!Number(input.value))
	arrivalUpdateDataset(liNode, 'quantity', Number(input.value))
}

// Input handler
function arrivalInputHandler(input, selector) {
	const liNode = input.closest(selector)

	input.value = input.value.replace('/[0-9]/', '')

	if (Number(input.value) < 0) {
		input.value = 0
	}

	arrivalCheckboxHandler(liNode, !!Number(input.value))
	arrivalUpdateDataset(liNode, 'quantity', Number(input.value))
}
